import { type StepVariant } from "@repo/types";

import { INITIAL_STATE, stampcardStore } from "./store";

function setProduct({
  productId,
  steps,
  forRule
}: {
  productId: string;
  steps: StepVariant[] | undefined;
  forRule?: string;
}) {
  stampcardStore.setState((state) => {
    const entry = { productId, steps, stampCardRuleId: undefined };
    if (!state.products) {
      state.products = [entry];
      return;
    }
    // Clear previous selection so the form's `values` prop doesn't pick up stale data
    if (forRule) {
      const previousSelection = state.products.find(
        (p) => p.stampCardRuleId === forRule && p.productId !== productId
      );
      if (previousSelection) {
        previousSelection.stampCardRuleId = undefined;
      }
    }

    const existingIndex = state.products.findIndex(
      (p) => p.productId === productId
    );
    if (existingIndex !== -1) {
      state.products[existingIndex] = entry;
    } else {
      state.products.push(entry);
    }
  });
}

type SetProductStampCardRuleIdArgs = {
  stampCardRuleId: string;
  productId: string;
};

function setProductStampCardRuleId({
  stampCardRuleId,
  productId
}: SetProductStampCardRuleIdArgs) {
  stampcardStore.setState((state) => {
    const product = (state.products ?? []).find(
      (p) => p.productId === productId
    );
    if (product) {
      product.stampCardRuleId = stampCardRuleId;
    }
  });
}

function reset() {
  stampcardStore.setState(INITIAL_STATE);
}

const stampcardActions = { setProduct, setProductStampCardRuleId, reset };

export { stampcardActions };
